module.exports = __webpack_public_path__ + "static/fipclilacrain2-9ef21b13b63b9679033c852437b9b707.jpeg";